// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInCalendarWeeks/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInCalendarWeeksWithOptions = convertToFP(fn, 3);
export default differenceInCalendarWeeksWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInCalendarWeeksWithOptions/index.js
// module id = 833
// module chunks = 0